const cache = {};

const loadData = (filename) => {
    if (!cache[filename]) {
        cache[filename] = fetch(`/data/${filename}`).then((res) => res.json());
    }

    return cache[filename];
};

export { loadData };
